import React, { useState } from "react";
import { Button, ButtonAction, Card, Form, FormItem, Input, FormItemGroup } from "asumsi-components";
import { Select } from "antd";

import SunEditor from 'suneditor-react';

export const SectionForm = (props: any) => {
    const { Option } = Select;
    const { isLoader, submitSection, cancelAddSection, fieldsValuesSection, checkPointType, sources, loaderSource, dataCrawl, loaderDataCrawl, getDataCrawl } = props;
    const [fieldsValues, setFieldsValues] = useState(fieldsValuesSection);
    const [content, setContent] = useState();
    const [touchLimit, setTouchLimit] = useState(0);
    const paramDefault = { page: 1, limit: 100, status: 'published' };

    const onChangeContent = (value: any) => {
        const regex = /(<([^>]+)>)/ig;
        const result = value.replace(regex, '');
        setTouchLimit(result.length);
        setContent(value);
    }

    const handleSubmit = () => {
        submitSection({ ...fieldsValues, content });
    }

    const changeSource1 = (value: string) => {
        const param = { ...paramDefault, newsMedia: value };
        getDataCrawl(param);
        setFieldsValues({ ...fieldsValues, source1: value, url1: undefined });
    }

    const changeUrl1 = (value: string) => {
        setFieldsValues({ ...fieldsValues, url1: value });
    }

    const onSearchUrl1 = (search: string) => {

        if (search.length > 3 || search.length == 0) {
            const param = { ...paramDefault, newsMedia: fieldsValues.source1, search };
            getDataCrawl(param);
        }
    }

    return <Card className="asumsi-card-form-shadow-rd-15">
        <Form titleBold>
            <FormItemGroup title="Timeline Checkpoint">
                {checkPointType == 2 ? <FormItem className="m-r-20" width="30%" setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                    fieldDecorator={{
                        label: "checkPointGroup",
                        rules: [{
                            message: 'Please input checkpont group',
                            required: true,
                        }
                        ]
                    }}
                >
                    <Input id="checkPointGroup" defaultValue={fieldsValues.checkPointGroup} placeHolder="Checkpoint group" />
                </FormItem> : null}
                <FormItem className="m-r-20" width="30%" setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                    fieldDecorator={{
                        label: "checkPoint",
                        rules: [{
                            message: 'Please input checkpont',
                            required: true,
                        }
                        ]
                    }}
                >
                    <Input id="checkPoint" defaultValue={fieldsValues.checkPoint} placeHolder="Checkpoint" />
                </FormItem>
                <FormItem width="40%" setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                    fieldDecorator={{
                        label: "checkPointDesc"
                    }}
                >
                    <Input id="checkPointDesc" defaultValue={fieldsValues.checkPointDesc} placeHolder="Checkpoint description" />
                </FormItem>
            </FormItemGroup>
            <FormItemGroup title="News">
                <FormItem className="m-r-10" width="40%" setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                    fieldDecorator={{
                        label: "source1"
                    }}
                >
                    <Select
                        loading={loaderSource}
                        showSearch
                        style={{ width: "100%" }}
                        onChange={changeSource1}
                        defaultValue={fieldsValues.source1}
                        allowClear={false}
                        optionFilterProp="children"
                        placeholder="Source">
                        {sources && sources.map((tp: any) => <Option key={tp.id} value={tp.id}>{tp.name}</Option>)}
                    </Select>
                </FormItem>
                <FormItem setFieldsValues={setFieldsValues} hideRequiredMark={true} fieldsValues={fieldsValues} labelAlign="left"
                    fieldDecorator={{
                        label: "url1"
                    }}
                >
                    <Select
                        loading={loaderDataCrawl}
                        showSearch
                        style={{ width: "100%" }}
                        onChange={changeUrl1}
                        value={fieldsValues.url1}
                        onSearch={onSearchUrl1}
                        defaultValue={fieldsValues.url1}
                        allowClear={false}
                        disabled={!fieldsValues.source1}
                        optionFilterProp="children"
                        placeholder="Url">
                        {dataCrawl && dataCrawl.map((tp: any) => <Option key={tp.id} value={tp.url}>{tp.url}</Option>)}
                    </Select>
                </FormItem>
            </FormItemGroup>
            <FormItem label="Content" className="m-b-20" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} labelAlign="left"
                fieldDecorator={{
                    label: "content",
                }}>
                <div>
                    <SunEditor setContents={fieldsValues.content} onChange={onChangeContent} height="280px" enableToolbar={true} setOptions={{
                        resizingBar: false,
                        mode: "classic",
                        font: ['Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'IBM Plex Serif', 'Impact', 'Inter', 'tahoma', 'Trebuchet MS', 'Verdana'],
                        katex: "window.katex",
                        imageGalleryUrl: "https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo",
                        buttonList: [
                            [
                                "undo",
                                "redo",
                                "font",
                                "fontSize",
                                "formatBlock",
                                "paragraphStyle",
                                "blockquote",
                                "bold",
                                "underline",
                                "italic",
                                "strike",
                                "subscript",
                                "superscript",
                                "fontColor",
                                "hiliteColor",
                                "textStyle",
                                "removeFormat",
                                "outdent",
                                "indent",
                                "align",
                                "horizontalRule",
                                "list",
                                "lineHeight",
                                "table",
                                "link",
                                "image",
                                "video",
                                "audio",
                                "math",
                                "imageGallery",
                                "fullScreen",
                                "showBlocks",
                                "codeView",
                                "preview",
                                "print",
                                "save"
                            ]
                        ],
                    }} />
                    {touchLimit > 280 ? <label style={{ color: "red" }}>Content cannot be longer then 280 characters, You entered {touchLimit}</label> : null}

                </div>
            </FormItem>
            <ButtonAction
                left={
                    <Button type="outline-red" size="medium" onClick={cancelAddSection} disabled={isLoader} text="Cancel"></Button>
                }
                right={
                    <Button width="120px" type="green" size="medium"
                        disabled={(fieldsValues.errors && fieldsValues.errors.length > 0) || touchLimit > 280}
                        loading={isLoader} onClick={handleSubmit} text="Save Section" />
                }
            />
        </Form>
    </Card>
}

export default SectionForm;


// WEBPACK FOOTER //
// ./src/pages/landing-page-form/libraries/section.tsx